import "./WoodDeckBuilders.module.css";
import Header from "@/reusable_sections/Header";
import HeroBanner from "./sections/HeroBanner";
import ConfiguratorHighlights from "./sections/ConfiguratorHighlights";
import AreaCoverageList from "./sections/AreaCoverageList";
import StartYourKitchenProject from "./sections/StartYourKitchenProject";
import Footer from "@/reusable_sections/Footer";
export default function WoodDeckBuildersPage() {
  return <div>
      <Header />
      <HeroBanner />
      <ConfiguratorHighlights />
      <AreaCoverageList />
      <StartYourKitchenProject />
      <Footer />
    </div>;
}